<template>
  <el-cascader
    :value="value"
    v-model="defaultArea"
    :props="defaultParams"
  ></el-cascader>
</template>

<script>
import db from '@/api/db' 
export default {
  props: {
    value: {
      type: Array,
      default: []
    },
    series:{
      type:Number,
      default:2
    }
  },
  data() {
    return {
      defaultArea: [],
      defaultParams: {
        lazy: true,
        series:this.series,
        lazyLoad(node, resolve) {
          const { level, value } = node;
          let params = { level: level + 1, pid: value };
          db.post(db.config.area.list, params).then(resp => {
            let data = resp.data;
            data.forEach(element => {
              element.leaf = level >= this.series
            })
            resolve(data);
          });
        }
      }
    };
  },
  methods: {
 
  },
  mounted() {
    this.defaultArea = this.value;
    
  },
  watch: {
    defaultArea(val) {
      this.$emit("input", val);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/dataArea/dataArea.vue